var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["card-background", { mobile: _vm.isMobile(_vm.$mq) }] },
    [
      !_vm.isMobile(_vm.$mq)
        ? _c(
            "svg",
            {
              staticClass: "background",
              attrs: {
                width: "476",
                height: "120",
                viewBox: "0 0 476 120",
                preserveAspectRatio: "none"
              }
            },
            [
              _c("path", {
                attrs: {
                  d:
                    "M0.525391 0.640625H72.3526L170.122 58.1406H482.935V120.641H0.525391V0.640625Z",
                  fill: _vm.learningPath.color_scheme.s_100
                }
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "image" },
        [
          _c("BriocheBackgroundImage", {
            attrs: { src: _vm.learningPath.image, width: 136 }
          })
        ],
        1
      ),
      _vm._v(" "),
      !_vm.isMobile(_vm.$mq)
        ? _c(
            "svg",
            {
              staticClass: "background",
              attrs: {
                width: "476",
                height: "120",
                viewBox: "0 0 476 120",
                preserveAspectRatio: "none"
              }
            },
            [
              _c("path", {
                attrs: {
                  d:
                    "M482.934 0.640625H411.128L313.388 72.207H0.669403V120.641H482.934V0.640625Z",
                  fill: _vm.learningPath.color_scheme.s_200
                }
              })
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }